import React from 'react';
import '../styles/IntegrationsMarquee.css';

const INTEGRATIONS = [
  'OpenAI',
  'Anthropic',
  'LangChain',
  'Temporal',
  'Postgres',
  'Snowflake',
  'BigQuery',
  'Salesforce',
  'HubSpot',
  'Stripe',
  'Slack',
  'Notion',
  'Twilio',
  'Vapi',
  'ElevenLabs',
  'Zendesk',
  'Intercom',
  'Rippling',
  'Gusto',
  'AWS',
  'GCP',
  'Vercel',
  'dbt',
  'Pinecone',
];

const IntegrationsMarquee: React.FC = () => {
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {[...INTEGRATIONS, ...INTEGRATIONS].map((name, i) => (
          <span key={i} className="marquee-item">
            {name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default IntegrationsMarquee;
